import { useState } from "react";
import DetailsPath from "./DetailsPath";
import UserDetails from "./UserDetails";
import ItemDetails from "./ItemDetails";
import QuickActions from "./QuickActions";

const Component: React.FC = () => {
  return (
    <div className="overflow-hidden h-full">
      <DetailsPath />
      {/* <div className="grid grid-cols-8 gap-x-4 divide-x-[0.5px]">
        <UserDetails />        
      </div> */}
      <div className="flex h-full">
        <div className="flex-0.5">
          <UserDetails />
        </div>

        <div className="flex flex-col justify-between flex-auto">
          <ItemDetails />
          <QuickActions />
        </div>
      </div>
    </div>
  );
};

export default Component;
